

















































import Vue from 'vue'
import { pickBy } from 'lodash'
import VideoPlayer from '@/components/VideoPlayer'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import { CastStream, SourceStream } from '@/types/streams'
import { UserProfile } from '@/types/users'
import { KeyDict } from '@/types'
import './PrivateCall.scss'

export default Vue.extend({
  name: 'PrivateCall',
  props: {
    currentUser: {
      type: Object as () => UserProfile,
      required: true
    },
    callingUser: {
      type: Object as () => UserProfile,
      required: false
    }
  },
  computed: {
    castStreams (): KeyDict<CastStream> {
      return this.$store.direct.state.streams.castStreams
    },
    sourceStreams (): KeyDict<Partial<SourceStream>> {
      return this.$store.direct.state.events.currentCast.source_streams
    },
    callingStreamId (): string|undefined {
      return this.getStreamIdOfCaster(this.callingUser.id, this.sourceStreams)
    },
    callingStream (): CastStream|undefined {
      if (this.callingStreamId === undefined) return undefined
      return this.getCastStream(this.callingStreamId, this.castStreams)
    },
    myStreamId (): string|undefined {
      return this.getStreamIdOfCaster(this.currentUser.id, this.sourceStreams)
    },
    myStream (): CastStream|undefined {
      if (this.myStreamId === undefined) return undefined
      return this.getCastStream(this.myStreamId, this.castStreams)
    },
    currentUserName (): string {
      let name = `${ this.currentUser.first_name } ${ this.currentUser.last_name }`
      if (this.currentUser.anonymous && this.currentUser.display_name) {
        name = this.currentUser.display_name
      }
      return name
    }
  },
  methods: {
    getStreamIdOfCaster (casterId: string, sourceStreams: KeyDict<Partial<SourceStream>>): string | undefined {
      const streams = pickBy(sourceStreams, (value) => value.user_id === casterId)
      const streamIds = Object.keys(streams)
      return streamIds.find(id => this.getCastStream(id, this.castStreams) !== undefined)
    },
    getCastStream (casterStreamId: string, castStreams: KeyDict<CastStream>): CastStream | undefined {
      const id = `${casterStreamId}_lowrate`
      return castStreams[id]
    }
  },
  async created () {
    await this.$store.direct.dispatch.events.setInCast(true)
  },
  components: {
    VideoPlayer,
    ClipLoader
  }
})
